import React from 'react';
import { FaTable } from 'react-icons/fa';

interface TableButtonProps {
  onOpenInsertTableModal: () => void;
}

export const TableButton: React.FC<TableButtonProps> = ({ onOpenInsertTableModal }) => {
  return (
    <button
      className='toolbar-button'
      onClick={onOpenInsertTableModal}
      title='テーブル'
      type='button'
    >
      <FaTable />
    </button>
  );
};
